var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"thumb",attrs:{"to":_vm.$relativeUrl(_vm.data.link)}},[(_vm.data.gds_featured_image)?_c('Figure',{attrs:{"data":{
      value: {
        src: _vm.data.gds_featured_image,
      },
      settings: {},
    },"theme":"default"}}):_vm._e(),_c('Heading',{staticClass:"title",class:_vm.$mq.breakpoint === '0' ? 'title-mob' : 'title-dsk',attrs:{"value":_vm.data.title.rendered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }